import { render } from "./CustomerIdentifierForm.vue?vue&type=template&id=a7720366"
import script from "./CustomerIdentifierForm.vue?vue&type=script&lang=js"
export * from "./CustomerIdentifierForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__